import { AcceptInvitePage } from '@/containers';

export const AcceptInvite = () => {
  return <AcceptInvitePage />;
};
